module.exports = __webpack_public_path__ + "static/media/arrow-up.69e98d6b.svg";